(() => {
  const MOBILE_QUERY = '(max-width: 989px)';
  const mobileMedia = window.matchMedia(MOBILE_QUERY);

  const smileSelector = [
    '#smile-ui-container',
    '.smile-ui-container',
    '[id*="smile-ui"]',
    '[id*="Smile"]',
    '[class*="smile-launcher"]',
    '[class*="smile-ui"]',
    'iframe[src*="smile.io"]',
    'iframe[src*="smile-ui"]',
    'iframe[title*="Smile"]'
  ].join(',');

  const chatSelector = [
    '#shopify-chat',
    '#ShopifyChat',
    '.shopify-chat',
    '[id*="ShopifyChat"]',
    '[class*="shopify-chat"]',
    'iframe[src*="inbox.shopify"]',
    'iframe[src*="shopifychat"]',
    'iframe[title*="chat"]',
    'iframe[title*="Chat"]'
  ].join(',');

  function isMobileMenuOpen() {
    return Boolean(
      document.querySelector('#Details-menu-drawer-container[open]') ||
      document.querySelector('header-drawer details[open]') ||
      document.body.classList.contains('overflow-hidden-tablet')
    );
  }

  function isFixedOrFloating(element) {
    if (!element || element === document.documentElement || element === document.body) return false;
    const style = window.getComputedStyle(element);
    return style.position === 'fixed' || style.position === 'sticky' || style.position === 'absolute';
  }

  function chooseFloatingContainer(element, type) {
    let current = element;
    let best = element;
    const maxDepth = 6;

    for (let i = 0; current && i < maxDepth; i += 1) {
      const idClass = `${current.id || ''} ${current.className || ''}`.toLowerCase();
      if (type === 'smile' && idClass.includes('smile')) best = current;
      if (type === 'chat' && (idClass.includes('shopify-chat') || idClass.includes('inbox'))) best = current;
      if (isFixedOrFloating(current)) best = current;
      current = current.parentElement;
    }

    return best;
  }

  function findManagedElements(selector, type) {
    return Array.from(document.querySelectorAll(selector))
      .map((element) => chooseFloatingContainer(element, type))
      .filter((element, index, array) => element && array.indexOf(element) === index);
  }

  function applyFloatingWidgetRules() {
    const isMobile = mobileMedia.matches;
    const menuOpen = isMobile && isMobileMenuOpen();

    document.body.classList.toggle('dt-mobile-menu-active', menuOpen);

    const smileElements = findManagedElements(smileSelector, 'smile');
    smileElements.forEach((element) => {
      element.classList.add('dt-managed-smile-widget');
      if (isMobile) {
        element.style.setProperty('left', '1.6rem', 'important');
        element.style.setProperty('right', 'auto', 'important');
        element.style.setProperty('bottom', 'calc(1.6rem + env(safe-area-inset-bottom, 0px))', 'important');
      } else {
        element.classList.remove('dt-managed-smile-widget');
        element.style.removeProperty('left');
        element.style.removeProperty('right');
        element.style.removeProperty('bottom');
      }
    });

    const chatElements = findManagedElements(chatSelector, 'chat');
    chatElements.forEach((element) => {
      element.classList.toggle('dt-managed-chat-widget', isMobile);
    });
  }

  let queued = false;
  function scheduleApply() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      applyFloatingWidgetRules();
    });
  }

  document.addEventListener('DOMContentLoaded', scheduleApply);
  window.addEventListener('load', scheduleApply);
  window.addEventListener('resize', scheduleApply);
  document.addEventListener('click', () => window.setTimeout(scheduleApply, 120));
  document.addEventListener('keyup', scheduleApply);

  const observer = new MutationObserver(scheduleApply);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'open', 'style', 'id']
  });
})();
